// Shared Tailwind class strings for the admin panels
export const inputCls =
  "w-full bg-[#121212] border border-white/15 rounded-none px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-[#FF6B00] focus:ring-1 focus:ring-[#FF6B00] transition-colors";

export const labelCls = "block text-xs tracking-widest uppercase text-white/60 mb-2";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF6B00] hover:bg-[#E65A00] disabled:opacity-60 transition-colors px-6 py-3 font-display tracking-widest uppercase text-white text-sm";

export const btnSecondary =
  "inline-flex items-center justify-center gap-2 bg-transparent border border-white/20 hover:border-[#FF6B00] hover:text-[#FF6B00] transition-colors px-6 py-3 font-display tracking-widest uppercase text-white text-sm";

export const btnDanger =
  "inline-flex items-center justify-center gap-2 bg-transparent border border-red-500/40 text-red-400 hover:bg-red-500 hover:text-white transition-colors px-4 py-2 text-xs tracking-widest uppercase font-display";

export function PanelHeader({ title, description, eyebrow, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8 pb-6 border-b border-white/10">
      <div>
        {eyebrow && (
          <div className="font-display tracking-[0.3em] text-xs text-[#FF6B00] mb-2">{eyebrow}</div>
        )}
        <h1 className="font-display uppercase text-3xl md:text-4xl tracking-tight">{title}</h1>
        {description && <p className="text-white/60 mt-2">{description}</p>}
      </div>
      {actions && <div className="flex gap-3 flex-wrap">{actions}</div>}
    </div>
  );
}
